import { render, staticRenderFns } from "./RcsSuggestion.vue?vue&type=template&id=1394f070&scoped=true"
import script from "./RcsSuggestion.vue?vue&type=script&lang=js"
export * from "./RcsSuggestion.vue?vue&type=script&lang=js"
import style0 from "./RcsSuggestion.vue?vue&type=style&index=0&id=1394f070&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1394f070",
  null
  
)

export default component.exports